import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ActionSeverity, capturePageAction } from '@chegg/observability';
import { ProductType } from '@chegg/pricing-sdk';
import { getCvidCookie } from '@chegg/utils';
import { CW_TEAM_NAME } from '../constants/AppConstants';
var formatUuid = function formatUuid() {
  var code;
  try {
    code = window.crypto.randomUUID();
  } catch (e) {
    // Yes this is lazy https://www.geeksforgeeks.org/how-to-create-a-guid-uuid-in-javascript/
    // Given the presence of the crypto api in modern browsers,
    // I don't want to add another dependency.
    code = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }
  return code;
};
export var ALL_PURCHASE = 'allPurchase';
export var productEventMap = _defineProperty(_defineProperty(_defineProperty({}, ALL_PURCHASE, {
  entity_id: '25741880063',
  key: 'ow_purchase_event'
}), ProductType.CHEGG_STUDY, {
  entity_id: '25666500680',
  key: 'ow_cs_purchase'
}), ProductType.CHEGG_STUDY_PACK, {
  entity_id: '25763490141',
  key: 'ow_csp_purchase'
});
var formatEventsList = function formatEventsList(productType) {
  var timestamp = Date.now();
  var events = [// Send this event for all purchase cases.
  _objectSpread(_objectSpread({}, productEventMap[ALL_PURCHASE]), {}, {
    timestamp: timestamp,
    uuid: formatUuid()
  })];
  if (productType == ProductType.CHEGG_STUDY) {
    events.push(_objectSpread(_objectSpread({}, productEventMap[ProductType.CHEGG_STUDY]), {}, {
      timestamp: timestamp,
      uuid: formatUuid()
    }));
  }
  if (productType == ProductType.CHEGG_STUDY_PACK) {
    events.push(_objectSpread(_objectSpread({}, productEventMap[ProductType.CHEGG_STUDY_PACK]), {}, {
      timestamp: timestamp,
      uuid: formatUuid()
    }));
  }
  return events;
};
export var ENDPOINT = 'https://logx.optimizely.com/v1/events';
export var sendPurchaseEvent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(productType) {
    var events;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!productType || ![ProductType.CHEGG_STUDY, ProductType.CHEGG_STUDY_PACK].includes(productType))) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.prev = 2;
          events = formatEventsList(productType);
          _context.next = 6;
          return window.fetch(ENDPOINT, {
            method: 'POST',
            headers: new Headers({
              'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
              // The account_id does not vary by environment.
              // There is a single optimizely web account.
              // Events are only "counted" if the visitor_id is activated into
              // an optimizely web experiment. For ease of
              // validation, fire in all environments.
              account_id: '14932920627',
              visitors: [{
                // CVID is used as optimizely web visitor ID. Intentional.
                // eslint-disable-next-line camelcase
                visitor_id: getCvidCookie() || 'no-cvid',
                attributes: [],
                snapshots: [{
                  decisions: [],
                  events: events
                }]
              }],
              // eslint-disable-next-line camelcase
              anonymize_ip: true,
              enrich_decisions: true
            })
          });
        case 6:
          _context.next = 12;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](2);
          capturePageAction({
            action: _context.t0,
            location: 'Drop In Payment OptimizelyWebUtils sendPurchaseEvent',
            severity: ActionSeverity.WARNING
          }, {
            teamName: CW_TEAM_NAME
          });
          return _context.abrupt("return");
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 8]]);
  }));
  return function sendPurchaseEvent(_x) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/utils/OptimizelyWebUtils.js
// module id = 904
// module chunks = 11